import * as React from 'react';

import { Input } from '@clutter/clean';

import { FieldFormGroup } from './field_form_group';

export const InputFormGroup: React.FC<
  React.InputHTMLAttributes<HTMLInputElement> & {
    label: string;
    error?: string;
  }
> = ({ label, error, id, ...props }) => (
  <FieldFormGroup label={label} error={error} id={id}>
    <Input {...props} state={error ? 'error' : undefined} id={id} />
  </FieldFormGroup>
);
